import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	wrapper: {
		height: "100%"
	},
	container: {
		position       : "sticky",
		top            : "calc(6.2rem + 0.5vw)",
		zIndex         : "1200",
		display        : "flex",
		justifyContent : "space-evenly",
		borderRadius   : "10px",
		marginBottom   : "2rem"
	},
	selectedOverlay: {
		backgroundColor : "#126bd5",
		opacity         : "0.5",
		position        : "absolute",
		width           : "100%",
		height          : "100%"
	},
	moderatorModalWrapper: {
		// position        : "absolute",
		top             : "12%",
		left            : "24%",
		backgroundColor : "#fff",
		borderRadius    : "10px",
		width           : "50vw",
		minWidth        : "500px"
	},
	errorModalWrapper: {
		minWidth        : "400px",
		maxWidth        : "500px",
		width           : "40vw",
		padding         : "2rem",
		display         : "flex",
		flexDirection   : "column",
		alignItems      : "center",
		// position        : "absolute",
		// top             : "50%",
		// left            : "50%",
		// transform       : "translate(-50%, -50%)",
		backgroundColor : theme.other.colors.background.primary,
		borderRadius    : "10px",
		border          : "none",
		color           : theme.other.colors.text.primary,
		fontSize        : theme.other.typographyNew.fontSizeMapping["caption"]
	},
	errorIcon: {
		marginBottom : "2.5rem",
		opacity      : "60%"
	},
	text1: {
		fontWeight   : "500",
		marginBottom : "1rem",
		fontSize     : theme.other.typographyNew.fontSizeMapping["label"]
	},
	marginBottom: {
		marginBottom: "3rem"
	},
	manageButton: {
		width        : "100%",
		background   : "linear-gradient(to right,#439aff,#126bd5)",
		borderRadius : "10px",
		padding      : "1.5rem",
		color        : "#fff",
		border       : "none",
		fontWeight   : "500",
		fontSize     : "1.5rem"
	},
	crossButton: {
		cursor    : "pointer",
		transform : "scale(0.7)",
		position  : "absolute",
		right     : "0",
		top       : "0",
		margin    : "10px"
	},
	crossButtonInvert: {
		cursor    : "pointer",
		transform : "scale(0.7)",
		filter    : "invert(1)",
		position  : "absolute",
		right     : "0",
		top       : "0",
		margin    : "10px"
	}

} ), { name: "user-profile" } );
